<goab-drawer
  #drawer
  drawerCustomPosition
  testid="facility-display-drawer"
  [heading]="drawerHeaderTmplInstance"
  position="right"
  (onClose)="onDrawerClose()"
  [open]="isDrawerOpen()"
  maxSize="60vw"
>
  <router-outlet></router-outlet>
</goab-drawer>
<ng-template
  #drawerHeaderTmpl
  let-selectedFacilityName="selectedFacilityName"
  let-selectedFacilityStatus="selectedFacilityStatus"
>
  <div class="drawHeaderContainer" style="padding-left: 0.6rem">
    <goab-text
      class="heading"
      data-testid="data-entry-title"
      size="heading-l"
      tag="h1"
      mt="none"
      mb="xs"
    >
      {{ selectedFacilityName }}
    </goab-text>
    <goa-badge
      class="status-badge"
      data-testid="status-badge"
      [type]="selectedFacilityStatus | badgeTransform"
      content="{{ selectedFacilityStatus | alaEnumReverseMapping }}"
    ></goa-badge>
  </div>
</ng-template>
<ng-template #drawerHeaderTmplInstance>
  <ng-container
    *ngTemplateOutlet="
      drawerHeaderTmpl;
      context: {
        selectedFacilityName: selectedFacilityName(),
        selectedFacilityStatus: selectedFacilityStatus(),
      }
    "
  ></ng-container>
</ng-template>
